// Startup Component Builder

<template>
	<div class="bld-startup-main">
		<div class="title wi8_font">Startup Builder</div>

		<TheStartup />
		
		sourceName = {{ sourceName }} <br/>
		api url = {{ source.url }} <br/>
		ready = {{ ready }} <br/>

	</div>
</template>

<script>
import { mapState } from 'vuex';
import TheStartup from '@/components/TheStartup.vue';
export default {
	computed: {
		...mapState('app', ['ready']),
		...mapState('api', ['sourceName', 'source']),
	 },
	components: {
		TheStartup,
	},
}
</script>

<style scoped>
	.bld-startup-main {
		height: 100%;
		background-color: #EEFCEE;
		padding: 5px;
		border: solid 0px #999;
	}
	.title {
		color: #090;
	}
</style>
